import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs';

import { AgeVerificationActions } from './age-verification.slice';

@Injectable({ providedIn: 'root' })
export class AgeVerificationEffects {
  readonly onAgeVerification = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AgeVerificationActions.verifyAge),
        tap(() => {
          localStorage.setItem('ageVerified', 'true');
          const redirectURL =
            this.router.routerState.snapshot.root.queryParams['redirectURL'];
          if (redirectURL) {
            return this.router
              .navigateByUrl(redirectURL, {
                replaceUrl: true,
              })
              .catch(() => this.router.navigate(['/'], { replaceUrl: true }));
          } else {
            return this.router.navigate(['/'], { replaceUrl: true });
          }
        })
      ),
    { dispatch: false }
  );

  constructor(
    private readonly actions$: Actions,
    private readonly router: Router
  ) {}
}
